import { service } from '@maia/broker';
import { QueryOptions, queryOptions } from '@tanstack/react-query';

export type Brokers = Awaited<ReturnType<(typeof service)['findMany']>>;

export function getBrokersOptions(
  search: Record<string, unknown> = {},
  initialData: QueryOptions<Brokers>['initialData'] = undefined,
) {
  return queryOptions({
    queryKey: ['tasks', 'brokers'],
    queryFn: async () => await service.findMany(search),
    initialData,
  });
}
